import React, {Component} from 'react';
import Dashboard from './Dashboard';
import {GET_DASHBOARD} from '../queries';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { removeTrailingSlashes } from '../utils';
const nanoid = require('nanoid');

class Home extends Component<any, any> {
  refreshDashboardCallback:any;

  constructor(props: any) {
    super(props);
    this.refreshDashboard = this.refreshDashboard.bind(this);
  }

  onDashboardLoad(data:any) {
    this.setState({
      dashboardName: "Untitled"
    });
  }

  async refreshDashboard() {
    return this.refreshDashboardCallback();
  }

  assignRefetch(func:Function) {
    this.refreshDashboardCallback = func;
  }

  render() {
    const { match, currentUser, isLoading } = this.props;
    const params = match.params;
    return (
      <div className="App">
        <Query<any, any>
          query={GET_DASHBOARD}
          fetchPolicy="no-cache"
          notifyOnNetworkStatusChange={true}
          variables={{id: params.id}}
        >{
          ({data, loading, error, refetch, networkStatus}) => {
            if (networkStatus === 4) return <div>Refetching!</div>;
            if (loading || !data || isLoading) {
              return (<div>Loading...</div>);
            }
            if (error) {
              console.error(error);
              return (<div>Error!</div>);
            }
            const { syncarto_app_dashboard_by_pk } = data;
            this.assignRefetch(refetch);

            // combine the dashboard id with the session id
            const sessionToken = params.session ?  params.session : nanoid(8);
            const session = { id: (syncarto_app_dashboard_by_pk.id + '-' + sessionToken) };

            if (!params.session) {
              let path = removeTrailingSlashes(this.props.location.pathname);
              window.history.replaceState(null, "", `${path}/${sessionToken}`);
            }

            return (
              <Dashboard 
                currentUser={currentUser} 
                dashboardData={syncarto_app_dashboard_by_pk} 
                session={session} 
                dashboardId={syncarto_app_dashboard_by_pk.id}
                refetchDashboard={this.refreshDashboard} 
                isPublic={false} 
                userOrgs={this.props.userOrgs} 
                refreshAllCredentials={this.props.refreshAllCredentials} />
            );
          }
          }
        </Query>
        </div>
    );
  }
}

export default withRouter(Home);
